"use client";

import "./Hero.scss";

/**
 * Static hero slot (no shimmer) when Strapi is incomplete or while Suspense is pending.
 * Avoids an endless “loading” animation when data is missing.
 */
export default function HeroPlaceholder() {
  return (
    <div className="hero-section baseContainer" aria-hidden>
      <div
        className="maxWidth hero-maxWidth py-12 rounded-2xl"
        style={{
          minHeight: "min(70vh, 520px)",
          background: "var(--Colors-Neutral-Greys-50, #f3f3f4)",
        }}
      />
    </div>
  );
}
